import {FC} from 'react';

import {t} from 'i18next';

import newEmptyBasketImage from 'assets/images/new-empty-basket.png';
import {Button} from 'components/button/Button';

import {
  StyledBasketBodyEmptyWrapper,
  StyledDescription,
  StyledEmptyContainer,
  StyledEmptyContent,
  StyledEmptyImage,
  StyledTitle
} from './styles';

export type BasketEmptyBodyViewProps = {
  mediaURL: string;
  title: string;
  description: string;
  onAction?: () => void;
  buttonLabel?: string;
  loading: boolean;
  hideButton?: boolean;
};
export const BasketEmptyBodyView: FC<BasketEmptyBodyViewProps> = ({
  mediaURL,
  title,
  description,
  onAction,
  buttonLabel,
  loading,
  hideButton
}) => {
  return (
    <StyledBasketBodyEmptyWrapper>
      <StyledEmptyContainer>
        <StyledEmptyImage>
          <img src={mediaURL} alt="Empty" width={200} height={200} />
        </StyledEmptyImage>
        <StyledEmptyContent>
          <StyledTitle component={'h4'} variant={'h4'}>
            {title}
          </StyledTitle>
          <StyledDescription component={'p'} variant="body2">
            {description}
          </StyledDescription>
          {!hideButton && (
            <Button color="primary" shape="rounded" variant="contained" onClick={onAction} loading={loading}>
              {buttonLabel}
            </Button>
          )}
        </StyledEmptyContent>
      </StyledEmptyContainer>
    </StyledBasketBodyEmptyWrapper>
  );
};

export interface BasketDrawerEmptyBodyProps {
  onClick: () => void;
}

export const BasketEmptyBody: FC<BasketDrawerEmptyBodyProps> = (props) => {
  return (
    <BasketEmptyBodyView
      title={t('message.noProducts')}
      description={t('message.letsChange')}
      loading={false}
      onAction={() => {
        props.onClick();
      }}
      mediaURL={newEmptyBasketImage}
      buttonLabel={t('button.ctaBrowseCategory')}
    />
  );
};

BasketEmptyBody.displayName = 'BasketDrawerEmptyBody';
BasketEmptyBodyView.displayName = 'BasketDrawerEmptyBodyView';

export default BasketEmptyBody;
